module.exports = __webpack_public_path__ + "img/footerbg.476736d3.jpg";